document.addEventListener('DOMContentLoaded', () => {
    const footerMenuButton = document.querySelector('.footer-menu');
    const menu = document.querySelector('.footer-menu-list');

    if (footerMenuButton) {
        footerMenuButton.addEventListener('click', () => {
            footerMenuButton.classList.toggle('active');
            menu.classList.toggle('active');
        })
    }
})
